import React, { createContext, useContext, useState, useEffect } from 'react';

const OrdersDataContext = createContext({});
OrdersDataContext.displayName = 'OrdersDataContext';

export const useOrdersDataContext = () => {
  const context = useContext(OrdersDataContext);
  if (!context) throw new Error(`useOrdersDataContext must be used within OrdersDataProvider`);

  return context;
};

const RESULTSLIMITPERPAGE = process.env.REACT_APP_API_RESULTS_LIMIT || 10;

const emptyFilters = {
  year: '',
  month: '',
  orderNumber: '',
  media: '',
  fromDate: '',
  toDate: '',
  product: '',
  orderStatus: 'todas',
  conciliateStatus: 'todas',
  advertiser: '',
};

export const OrdersDataProvider = ({ children }) => {
  const [filter, setFilter] = useState(emptyFilters);
  const [pagination, setPagination] = useState({
    count: 0,
    limit: RESULTSLIMITPERPAGE,
    currentPage: 1,
    offset: 0,
  });

  useEffect(() => {
    console.log('📊 OrdersDataContext - montado/re-montado');
    return () => {
      console.log('📊 OrdersDataContext - desmontado');
    };
  }, []);

  return (
    <OrdersDataContext.Provider value={{ filter, setFilter, pagination, setPagination }}>
      {children}
    </OrdersDataContext.Provider>
  );
};
